module.exports = __webpack_public_path__ + "img/full2-min.a6b9c72c.png";